import React, { useContext, useEffect, useState } from 'react';
import LegendSelector from './LegendSelector';
import LegendContent from './LegendContent';
import SearchableSelect from './SearchableSelect';
import { AppContext } from '../components/AppContext';
import Loading from './Loading';
// import InfoCard from './InfoCard';
// import DoubleNumericChart from './DoubleNumericChart';
// import SingleNumericChart from './SingleNumericChart';
// import Loading from './Loading';

const ControlPanel = () => {
  // { geoserverUrl, map1, map1Layer, handleMap1Change, map1Data, setMap1Data, map1LegendData, map2, map2Layer, handleMap2Change, map2Data, setMap2Data, map2LegendData, legendConfig, setMap1Geom, setMap2Geom, loadMap1Option, loadMap2Option, setLoadMap1Option, setLoadMap2Option }
// const [map1Option, setMap1Option] = useState('')  
// const [map2Option, setMap2Option] = useState('')  
// const [map1SelectedValue, map1SetSelectedValue] = useState('');
// const [map2SelectedValue, map2SetSelectedValue] = useState('');

// const handleMap1Select = (option) => {
//   setMap1Option(option)
// };

// const handleMap2Select = (option) => {
//   setMap2Option(option)
// };

// let isDoubleNumeric = map1Data.type === 'numeric' && map2Data.type === 'numeric'
// let isSingle = !isDoubleNumeric

// if (map1Layer !== '' || map2Layer !== '') {

//     return (
//       <div className="legend">
//         {(loadMap1Option || loadMap2Option) && <Loading/>}
//         {(!loadMap1Option && !loadMap2Option) && <LegendSelector selectedValue={map1SelectedValue} setSelectedValue={map1SetSelectedValue} layer={map1Layer} setKey={handleMap1Change} setData={setMap1Data} legendConfig={legendConfig} />}
//         <SearchableSelect geoserverUrl={geoserverUrl} map={map1} mapLayer={map1Layer} setGeom={setMap1Geom} load={setLoadMap1Option} m2load={loadMap1Option || loadMap2Option} onSelect={(option) => handleMap1Select(option)} />
//         {(!loadMap1Option && !loadMap2Option) && isSingle && map1Data.type === 'string' && <InfoCard geoserverUrl={geoserverUrl}  layerName={map1Layer} mapData={map1Data} option={map1Option} color="blue" />}
//         {(!loadMap1Option && !loadMap2Option) && isSingle && map1Data.type === 'numeric' && <SingleNumericChart geoserverUrl={geoserverUrl} mapLayerName={map1Layer} mapData={map1Data} mapLegendData={map1LegendData} mapOption={map1Option} />}
//         {(!loadMap1Option && !loadMap2Option) && <LegendSelector selectedValue={map2SelectedValue} setSelectedValue={map2SetSelectedValue} layer={map2Layer} setKey={handleMap2Change} setData={setMap2Data} legendConfig={legendConfig} />}
//         <SearchableSelect geoserverUrl={geoserverUrl} map={map2} mapLayer={map2Layer} setGeom={setMap2Geom} load={setLoadMap2Option} m2load={loadMap1Option || loadMap2Option} onSelect={(option) => handleMap2Select(option)} />
//         {(!loadMap1Option && !loadMap2Option) && isSingle && map2Data.type === 'string' && <InfoCard geoserverUrl={geoserverUrl}  layerName={map2Layer} mapData={map2Data} option={map2Option} color="red" />}
//         {(!loadMap1Option && !loadMap2Option) && isSingle && map2Data.type === 'numeric' && <SingleNumericChart geoserverUrl={geoserverUrl} mapLayerName={map2Layer} mapData={map2Data} mapLegendData={map2LegendData} mapOption={map2Option} />}
//         {(!loadMap1Option && !loadMap2Option) && isDoubleNumeric && <DoubleNumericChart geoserverUrl={geoserverUrl} map1LayerName={map1Layer} map1Data={map1Data} map1LegendData={map1LegendData} map2LayerName={map2Layer} map2Data={map2Data} map2LegendData={map2LegendData} map1Option={map1Option} map2Option={map2Option} />}
//       </div>
//     );  
// };
// return(<div className="legend">aaa</div>)
const { mapData, globalLoading } = useContext(AppContext);
const [legend, setLegend] = useState(false);

useEffect( () => {
  if (mapData) setLegend(mapData.legend)
}, [mapData])

return(
  <div className="legend">
    {globalLoading && <Loading/>}
    {!globalLoading && <LegendSelector />}
    <SearchableSelect />
    <LegendContent />
  </div>
  )
}
export default ControlPanel;